import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'participantType',
    'higherCommitmentSelect',
    'boardAccountSelect',
    'emailInput',
    'submitButton'
  ]

  connect () {
    this.updateButtonState()
    this.addEventListeners()
  }

  addEventListeners () {
    this.participantTypeTargets.forEach(radio => {
      radio.addEventListener('change', () => this.updateButtonState())
    })

    if (this.hasHigherCommitmentSelectTarget) {
      this.higherCommitmentSelectTarget.addEventListener('change', () => this.updateButtonState())
    }

    if (this.hasBoardAccountSelectTarget) {
      this.boardAccountSelectTarget.addEventListener('change', () => this.updateButtonState())
    }

    if (this.hasEmailInputTarget) {
      this.emailInputTarget.addEventListener('input', () => this.updateButtonState())
    }
  }

  update () {
    this.updateButtonState()
  }

  getSelectedParticipantType () {
    const selected = this.participantTypeTargets.find((el) => el.checked)
    return selected?.value
  }

  updateButtonState () {
    const participantType = this.getSelectedParticipantType()

    const higherCommitmentValid =
      this.hasHigherCommitmentSelectTarget &&
      [...this.higherCommitmentSelectTarget.selectedOptions].length > 0

    const boardAccountChoicesWrapper = this.boardAccountSelectTarget.closest('.choices')
    const placeholder = boardAccountChoicesWrapper?.querySelector('.choices__placeholder[aria-selected="true"]')

    const boardAccountValid = this.hasBoardAccountSelectTarget && !placeholder

    const emailValid =
      this.hasEmailInputTarget &&
      this.emailInputTarget.value?.trim() !== ''

    let shouldEnable = false

    if (participantType === 'guest') {
      shouldEnable = higherCommitmentValid && emailValid
    } else if (participantType === 'board_member') {
      shouldEnable = higherCommitmentValid && boardAccountValid
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !shouldEnable
    }
  }
}
